export const SET_GALLERY = 'SET_GALLERY';
export const ADD_TO_GALLERY = 'ADD_TO_GALLERY';
export const UPDATE_GALLERY_ITEM = 'UPDATE_GALLERY_ITEM';
export const DELETE_FROM_GALLERY = 'DELETE_FROM_GALLERY';
export const SET_GALLERY_UNIQUE = 'SET_GALLERY_UNIQUE';